import { nameOfObjectKeys } from '.';

/**
 * Creates an array of enum members that doesn't have the reversed equivalent of a given member in an enum.
 * @param enumerator TypeScript enum to create an enumerable from
 * @param keys List of members you would like to include. This is more than likely every member.
 * @returns An array of enum members transformed into entries.
 */
export const createEnumerableEnum = <E extends Record<keyof E, unknown>>(
  enumerator: E,
  keys?: (keys: Record<keyof E, keyof E>) => Array<keyof E>
): Array<[keyof E, E[keyof E]]> => {
  const enumKeys = nameOfObjectKeys(enumerator);
  const wantedKeys = keys?.(enumKeys);

  return (wantedKeys ?? (Object.keys(enumKeys) as Array<keyof E>)).map(key => [key, enumerator[key]]);
};
